'use strict';

/* Views */
import SurveyList from './list/survey-list.component';
import SurveyEditor from './edit/survey-editor.component';
import SurveyShow from './show/survey-show.component';
import SurveyForm from './form/survey-form.component';

/* Services */
import SurveysService from '../../components/surveys/surveys.service';
import SurveyResultsService from '../../components/survey-results/survey-results.service';

export default angular.module('conduu.surveys', [
  SurveyList, SurveyEditor, SurveyShow, SurveyForm,
  SurveysService, SurveyResultsService])
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/index.js